export type ComponentAppearance = 'default' | 'fill';

export interface ComponentAppearanceConfig {
  appearance: ComponentAppearance;
}
export const COMPONENT_APPEARANCE_DEFAULT_CONFIG = {
  appearance: 'default' as ComponentAppearance,
};
